import { useCallback, useEffect, useState } from "react";

import { useSubscribe } from "data/messages/hooks";

function useSubscribeToSubscriptionChanged({ onSubscriptionChanged }) {
  const [subscription, setSubscription] = useState(null);

  useEffect(() => {
    if (subscription) {
      onSubscriptionChanged(subscription?.[0]);
      setSubscription(null);
    }
  }, [subscription, onSubscriptionChanged]);

  useSubscribe(
    "subscriptionChanged",
    useCallback((s) => {
      if (s.size > 0) setSubscription([...s]);
    }, [])
  );
}

export default useSubscribeToSubscriptionChanged;
